import { NavLink, Outlet } from 'react-router-dom';

export function PoliciesLayout() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tightish text-ink-primary">Policies</h1>
        <p className="mt-1 text-sm text-ink-secondary">
          Constraints applied to every agent signing through Sigil. Sessions, global rules, and the
          token registry the policies reference all live here. Agents that use these policies are
          built and run from{' '}
          <a
            href="https://agents.sigilkeys.com"
            target="_blank"
            rel="noreferrer"
            className="font-medium text-bit2me hover:underline"
          >
            agents.sigilkeys.com
          </a>
          .
        </p>
      </div>

      <nav className="flex gap-1 border-b border-line-soft">
        <Tab to="/policies" end label="Sessions" />
        <Tab to="/policies/rules" label="Global rules" />
        <Tab to="/policies/tokens" label="Tokens" />
      </nav>

      <Outlet />
    </div>
  );
}

function Tab({ to, label, end = false }: { to: string; label: string; end?: boolean }) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        `border-b-2 px-4 py-2 text-sm font-medium transition-colors ${
          isActive
            ? 'border-bit2me text-ink-primary'
            : 'border-transparent text-ink-tertiary hover:text-ink-primary'
        }`
      }
    >
      {label}
    </NavLink>
  );
}
